import React, { useCallback } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import i18n from 'src/i18n/i18n';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from 'src/constants';

import './languageSwitcher.scss';

export const LanguageSwitcher = ({ className = '' }) => {
  const { t } = useTranslation('app_languages');

  const activeLanguage = SUPPORTED_LANGUAGES.includes(i18n.resolvedLanguage)
    ? i18n.resolvedLanguage
    : DEFAULT_LANGUAGE;

  const onSelectLanguage = useCallback((language) => {
    if (!SUPPORTED_LANGUAGES.includes(language)) return;

    localStorage.setItem('language', language);

    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, []);

  const options = SUPPORTED_LANGUAGES.map((language) => ({
    value: language,
    label: t(language)
  }));

  return (
    <Select
      className={`landing-language-switcher ${className}`.trim()}
      value={activeLanguage}
      onChange={onSelectLanguage}
      options={options}
      size="medium"
    />
  );
};
